import { render, staticRenderFns } from "./not-certified.vue?vue&type=template&id=d9b6d2e2&scoped=true"
import script from "./not-certified.vue?vue&type=script&lang=js"
export * from "./not-certified.vue?vue&type=script&lang=js"
import style0 from "./not-certified.vue?vue&type=style&index=0&id=d9b6d2e2&prod&lang=scss&scoped=scoped"
import style1 from "./not-certified.vue?vue&type=style&index=1&id=d9b6d2e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b6d2e2",
  null
  
)

export default component.exports